import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import { Helmet } from 'react-helmet';

export class CanonincalFallback extends PureComponent {
    static defaultProps = {
        urlLocation: '',
        urlParams: '',
        hostname: '',
    };

    static propTypes = {
        urlLocation: PropTypes.string,
        urlParams: PropTypes.string,
        hostname: PropTypes.string,
    };

    render() {
        const { hostname, urlLocation, urlParams } = this.props;
        const canonicalUrl = !_isEmpty(urlParams)
            ? `https://${hostname}${urlLocation}${urlParams}`
            : `https://${hostname}${urlLocation}`;

        return (
            <Helmet>
                <link data-react-helmet="true" rel="canonical" href={canonicalUrl} />
            </Helmet>
        );
    }
}

const mapStateToProps = (state) => {
    const { context: { hostname = 'www.jcpenney.com' } = {}, urlLocation, urlParams } = state;

    return {
        hostname,
        urlLocation,
        urlParams,
    };
};

export default connect(mapStateToProps)(CanonincalFallback);
